import { FC } from 'react';
import { Center, VStack } from '@chakra-ui/react';

import magnifyingGlass from 'assets/brand/mag-glass.png';
import {
  GetInvoicesQueryHookResult,
  InvoiceFromList,
} from 'common/hooks/useGetInvoicesQuery';
import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import WorkListEmptyView from 'features/Work/components/WorkListEmptyView';

import Item from './components/Item';
import locales from './locales';

interface ListProps {
  invoices: InvoiceFromList[];
  pageInfo: GetInvoicesQueryHookResult['pageInfo'] | undefined;
  onFetchMore: () => void;
  onSelectItem: (invoiceId: string) => void;
  isFetchingMore?: boolean;
}

const List: FC<ListProps> = ({
  invoices,
  isFetchingMore,
  onFetchMore,
  onSelectItem,
  pageInfo,
}) => {
  if (invoices.length === 0) {
    return (
      <WorkListEmptyView imageSrc={magnifyingGlass} title={locales.noResult} />
    );
  }

  return (
    <VStack align="stretch" overflowY="auto" paddingBottom="space-32">
      <SunshineCard.RadioGroup onChange={onSelectItem}>
        <SunshineCard.Group>
          {invoices.map((invoice) => (
            <Item invoice={invoice} key={invoice.invoiceId} />
          ))}
        </SunshineCard.Group>
      </SunshineCard.RadioGroup>

      {pageInfo?.hasNextPage ? (
        <Center paddingTop="space-32">
          <Button
            icon="arrow-down"
            isLoading={isFetchingMore}
            onClick={onFetchMore}
            variant="secondary"
          >
            {locales.seeMore}
          </Button>
        </Center>
      ) : null}
    </VStack>
  );
};

export default List;
